import { createGlobalStyle } from 'styled-components'
import { appResource } from '@jarvis.oddle/core/env'

export default createGlobalStyle`
  /* stylelint-disable at-rule-empty-line-before */
  @font-face {
    font-family: 'Abhaya Libre';
    src: url(${appResource('/fonts/AbhayaLibre-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Abhaya Libre';
    src: url(${appResource('/fonts/AbhayaLibre-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Abril Fatface';
    src: url(${appResource('/fonts/AbrilFatface-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Arimo';
    src: url(${appResource('/fonts/Arimo-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Arimo';
    src: url(${appResource('/fonts/Arimo-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Arsenal';
    src: url(${appResource('/fonts/Arsenal-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Arsenal';
    src: url(${appResource('/fonts/Arsenal-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Arvo';
    src: url(${appResource('/fonts/Arvo-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Arvo';
    src: url(${appResource('/fonts/Arvo-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Berkshire Swash';
    src: url(${appResource('/fonts/BerkshireSwash-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Be Vietnam Pro';
    src: url(${appResource('/fonts/BeVietnamPro-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Be Vietnam Pro';
    src: url(${appResource('/fonts/BeVietnamPro-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Bitter';
    src: url(${appResource('/fonts/Bitter-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Bitter';
    src: url(${appResource('/fonts/Bitter-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Bree Serif';
    src: url(${appResource('/fonts/BreeSerif-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Cabin';
    src: url(${appResource('/fonts/Cabin-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Cabin';
    src: url(${appResource('/fonts/Cabin-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Cantora One';
    src: url(${appResource('/fonts/CantoraOne-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Courgette';
    src: url(${appResource('/fonts/Courgette-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Coustard';
    src: url(${appResource('/fonts/Coustard-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Glegoo';
    src: url(${appResource('/fonts/Glegoo-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Glegoo';
    src: url(${appResource('/fonts/Glegoo-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Hammersmith One';
    src: url(${appResource('/fonts/HammersmithOne-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Hind Guntur';
    src: url(${appResource('/fonts/HindGuntur-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Hind Guntur';
    src: url(${appResource('/fonts/HindGuntur-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Josefin Sans';
    src: url(${appResource('/fonts/JosefinSans-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Josefin Sans';
    src: url(${appResource('/fonts/JosefinSans-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Jost';
    src: url(${appResource('/fonts/Jost-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Jost';
    src: url(${appResource('/fonts/Jost-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Josefin Sans';
    src: url(${appResource('/fonts/JosefinSans-300.woff')}) format('woff');
    font-weight: 300;
  }
  @font-face {
    font-family: 'Kalam';
    src: url(${appResource('/fonts/Kalam-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Kalam';
    src: url(${appResource('/fonts/Kalam-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Lato';
    src: url(${appResource('/fonts/Lato-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Lato';
    src: url(${appResource('/fonts/Lato-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Libre Baskerville';
    src: url(${appResource('/fonts/LibreBaskerville-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Libre Baskerville';
    src: url(${appResource('/fonts/LibreBaskerville-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Libre Franklin';
    src: url(${appResource('/fonts/LibreFranklin-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Libre Franklin';
    src: url(${appResource('/fonts/LibreFranklin-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Lora';
    src: url(${appResource('/fonts/Lora-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Lora';
    src: url(${appResource('/fonts/Lora-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Merriweather';
    src: url(${appResource('/fonts/Merriweather-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Merriweather';
    src: url(${appResource('/fonts/Merriweather-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Merriweather';
    src: url(${appResource('/fonts/Merriweather-300.woff')}) format('woff');
    font-weight: 300;
  }
  @font-face {
    font-family: 'Nunito Sans';
    src: url(${appResource('/fonts/NunitoSans-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Nunito Sans';
    src: url(${appResource('/fonts/NunitoSans-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Nunito Sans';
    src: url(${appResource('/fonts/NunitoSans-300.woff')}) format('woff');
    font-weight: 300;
  }
  @font-face {
    font-family: 'Oregano';
    src: url(${appResource('/fonts/Oregano-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Oswald';
    src: url(${appResource('/fonts/Oswald-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Oswald';
    src: url(${appResource('/fonts/Oswald-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Pacifico';
    src: url(${appResource('/fonts/Pacifico-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Playfair Display';
    src: url(${appResource('/fonts/PlayfairDisplay-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Playfair Display';
    src: url(${appResource('/fonts/PlayfairDisplay-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Prata';
    src: url(${appResource('/fonts/Prata-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Quattrocento';
    src: url(${appResource('/fonts/Quattrocento-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Quattrocento';
    src: url(${appResource('/fonts/Quattrocento-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Quicksand';
    src: url(${appResource('/fonts/Quicksand-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Quicksand';
    src: url(${appResource('/fonts/Quicksand-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Roboto';
    src: url(${appResource('/fonts/Roboto-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Roboto';
    src: url(${appResource('/fonts/Roboto-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Roboto Slab';
    src: url(${appResource('/fonts/RobotoSlab-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Roboto Slab';
    src: url(${appResource('/fonts/RobotoSlab-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Rye';
    src: url(${appResource('/fonts/Rye-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Sanchez';
    src: url(${appResource('/fonts/Sanchez-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Signika';
    src: url(${appResource('/fonts/Signika-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Signika';
    src: url(${appResource('/fonts/Signika-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Trocchi';
    src: url(${appResource('/fonts/Trocchi-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Ubuntu';
    src: url(${appResource('/fonts/Ubuntu-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Ubuntu';
    src: url(${appResource('/fonts/Ubuntu-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Vollkorn';
    src: url(${appResource('/fonts/Vollkorn-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: 'Vollkorn';
    src: url(${appResource('/fonts/Vollkorn-700.woff')}) format('woff');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Yeseva One';
    src: url(${appResource('/fonts/YesevaOne-regular.woff')}) format('woff');
    font-weight: normal;
  }
  @font-face {
    font-family: '中文 STSong';
    src: url(${appResource('/fonts/chinese.stsong.woff')}) format('woff');
    font-weight: normal;
  }
  /* stylelint-enable at-rule-empty-line-before */
`
